


































import BaseForm from '@/components/common/BaseForm.vue';
import { BeforeLeaveGuard } from '@/components/mixins/BeforeLeaveGuard';
import { Classification } from '@/models/device/models';
import Vue from 'vue';
import Component from 'vue-class-component';
import ParentSelectors from '@/components/common/ParentSelectors.vue';
import ObjectBreadcrumbs from '@/components/common/ObjectBreadcrumbs.vue';

import { deviceRouteName } from '../app';

@Component({
  name: 'classification-form',
  components: {
    BaseForm,
    ParentSelectors,
    ObjectBreadcrumbs,
  },
  props: {
    id: {
      required: true,
    },
  },
  data() {
    return {
      classification: Classification,
    };
  },
  mixins: [BeforeLeaveGuard],
  methods: {
    deviceRouteName,
  },
})
export default class ClassificationForm extends Vue {
  classification: Classification;
  loading = false;

  mounted() {
    this.loading = true;
    this.$api.get('classification', this.$props.id).then(response => {
      this.classification = response;
      this.loading = false;
    });
  }

  updated() {
    this.classification.model =
      this.$store.getters['global/model'] &&
      this.$store.getters['global/model'].id;
  }

  get isNew() {
    return this.$props.id === '0';
  }
}
